// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XProductFilters } from "@guestsupply/XDL/types";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DisplayProductsResult,
    ParseQueryParameter,
    SetExpandTokens,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import qs from "qs";

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

type HandlerType = Handler<Parameter, Props>;

export const XngSetExpandTokens: HandlerType = props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "badges", "properties"];

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
};
export const XngParseQueryParameter: typeof ParseQueryParameter = props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString);
    const { isAvendraPricing, brandStandards } = parsedQuery;

    const splitCommaSeparated = (value?: string | string[] | null) =>
        value && typeof value === "string" ? value.split(",") : undefined;

    if ((props.parameter as any).pageSize) {
        props.result.productFilters.pageSize = (props.parameter as any).pageSize;
    }

    if (isAvendraPricing !== undefined) {
        (props.result.productFilters as XProductFilters).isAvendraPricing = true;
    }
    if (brandStandards) {
        (props.result.productFilters as XProductFilters).brandStandards = splitCommaSeparated(brandStandards);
    }
};

replaceInChain(chain, SetExpandTokens, XngSetExpandTokens);
addToChainAfter(chain, ParseQueryParameter, XngParseQueryParameter);
